import Vue from 'vue';
import BzbsApi from '@/service/BzbsApi.js';
import Locale from '@/helper/locale/locale.js';

/**
 * @method checkIsMember
 * @method registerMember
 * @method registerQr
 * @method isUserRegistered
 * @method updateMember
 */
export default {
    config: function() {
        return Vue.bzbsConfig;
    },

    /**
     * @param {String} token
     * @param {String} contactNumber
     * @param {String} birthday dd/mm
     * @param {String} lineUserId
     */
    checkIsMember: function(token, contactNumber, birthday, Idtoken) {
        var params = {
            contactnumber: contactNumber,
            birthday: birthday,
            id_token: Idtoken,
        };

        var url = this.config().bzbsModuleUrl + "/member/ismember";
        return BzbsApi.connectBzbsGet(url, token, params);
    },

    /**
     * @param {string} token
     * @param {Object} params DiorRegisterModel - /model/Dior/DiorRegisterModel.js
     */
    registerMember: function(token, params, idToken) {
        params.id_token = idToken;
        var url = this.config().bzbsModuleUrl + "/member/createdigitalmember";
        return BzbsApi.connectBzbsPost(url, token, params);
    },

    /**
     * @param {string} token
     * @param {string} customerId
     * @param {string} counterId
     * @param {string} contactNumber
     */
    registerQr: function(token, customerId, counterId, contactNumber, birthDay, birthMonth, dataOtp, Idtoken) {
        var params = {
            membercode: customerId,
            mobilenumber: contactNumber,
            countercode: counterId,
            birthday: birthDay,
            birthmonth: birthMonth,
            refcode: dataOtp.refcode,
            otp: dataOtp.otp,
            id_token: Idtoken,
        };
        var url = this.config().bzbsModuleUrl + "/member/processmember";
        return BzbsApi.connectBzbsPost(url, token, params);
    },

    /**
     * @param {string} token
     * @param {string} lineId
     */
    isUserRegistered: function(token, lineId) {
        var params = {
            id_token: lineId,
        };
        var url = this.config().bzbsModuleUrl + "/member/ismemberbychannel";
        return BzbsApi.connectBzbsGet(url, token, params);
    },

    /**
     * @param {string} token
     * @param {Object} params DiorRegisterModel - /model/Dior/DiorRegisterModel.js
     */
    updateMember: function(token, params) {
        var url = this.config().bzbsModuleUrl + "/member/updatemember";
        return BzbsApi.connectBzbsPost(url, token, params);
    },
    getdateReserve: function(token, serviceCode, counterCode ) {
        let locale = Locale.getLocaleCode();
        var localeCode = locale == "1054" ? "th-TH" : "en-US"
        var params = {
            serviceCode: serviceCode,
            counterCode: counterCode,
            culture: localeCode,

        }
        var url = this.config().bzbsModuleUrl + "/event/datelist";
        return BzbsApi.connectBzbsGet(url, token, params);
    },
    getCounterList: function(token, serviceCode) {
        let locale = Locale.getLocaleCode();
        var localeCode = locale == "1054" ? "th-TH" : "en-US"
        var params = {
            serviceCode: serviceCode,
            culture: localeCode,

        }
        var url = this.config().bzbsModuleUrl + "/event/counterlist";
        return BzbsApi.connectBzbsGet(url, token, params);
    },
    geStaffList: function(token, serviceCode, counterCode) {
        let locale = Locale.getLocaleCode();
        var localeCode = locale == "1054" ? "th-TH" : "en-US"
        var params = {
            serviceCode: serviceCode,
            counterCode: counterCode,
            culture: localeCode,

        }
        // params.serviceCode = "TD21XMAS01";
        // params.counterCode = "1564";
        var url = this.config().bzbsModuleUrl + "/event/stafflist";
        return BzbsApi.connectBzbsPost(url, token, params);
    },
    gettimeReserve: function(token, serviceCode, counterCode , date, staffCode) {
        let locale = Locale.getLocaleCode();
        var localeCode = locale == "1054" ? "th-TH" : "en-US"
        var params = {
            serviceCode: serviceCode,
            counterCode: counterCode,
            date: date,
            culture: localeCode,
        }

        if (staffCode) {
            params.staffCode = staffCode;
        }

        var url = this.config().bzbsModuleUrl + "/event/timelist";
        return BzbsApi.connectBzbsGet(url, token, params);
    },
    bookingDior: function(token, dataInfo) {
        let locale = Locale.getLocaleCode();
        var localeCode = locale == "1054" ? "th-TH" : "en-US"
        var params = {
            campaignId: dataInfo.campaignId,
            branchName: dataInfo.brance ? dataInfo.brance : null,
            date: dataInfo.date,
            counterCode: dataInfo.counterCode ? dataInfo.counterCode : null,
            serviceCode: dataInfo.serviceCode,
            timeFrom: dataInfo.timeFrom,
            timeTo: dataInfo.timeTo,
            memberCode: dataInfo.membercode ? dataInfo.membercode : dataInfo.membercode,
            fullname: dataInfo.firstname + " " + dataInfo.lastname,
            contactNumber: dataInfo.contactNumber ? dataInfo.contactNumber : null,
            culture: localeCode,
            staffCode: dataInfo.staffCode,
            Channel: dataInfo.chanel ? dataInfo.chanel  : null,

        }
        var url = this.config().bzbsModuleUrl + "/event/book";
        return BzbsApi.connectBzbsPost(url, token, params);
    },
    cancelBookingDior: function(token, purchase) {
        let locale = Locale.getLocaleCode();
        var localeCode = locale == "1054" ? "th-TH" : "en-US"
        var params = {
            eventName: purchase.serviceName,
            branchName: purchase.counterName,
            fullname: purchase.memberName,
            date: purchase.date,
            sequence: purchase.sequence,
            timeFrom: purchase.timeFrom,
            timeTo: purchase.timeTo,
            culture: localeCode,

        }
        var url = this.config().bzbsModuleUrl + "/event/cancel";
        return BzbsApi.connectBzbsPost(url, token, params);
    },

    cancelRedeemGift: function(token, purchase, type) {
        var params = {
            memberCode: purchase.dataInfo.membercode,
            orderCode: purchase.orderCode,
            name: purchase.dataInfo.firstName,
        }
        var url = this.config().bzbsModuleUrl + "/gift/expiration";
        if (type == "GI" || type == "GF") {
            url = this.config().bzbsModuleUrl + "/gift/cancel";
        }
        return BzbsApi.connectBzbsPost(url, token, params);
    },
}
